import { Action, Selector, State, type StateContext } from "@ngxs/store";

import { Service } from "@angular/core";

import { ClearSession, SetSession } from "./session.actions";

export interface SessionStateModel {
  ssoToken: string | null;
  refreshToken: string | null;
  expiresInSeconds: number | null;
  expiresAt: string | null;
}

@State<SessionStateModel>({
  name: "Session",
  defaults: {
    ssoToken: null,
    refreshToken: null,
    expiresInSeconds: null,
    expiresAt: null,
  },
})
@Service({ autoProvided: false })
export class SessionState {
  @Selector()
  static ssoToken(state: SessionStateModel): string | null {
    return state?.ssoToken;
  }

  @Selector()
  static refreshToken(state: SessionStateModel): string | null {
    return state?.refreshToken;
  }

  @Selector()
  static expiresInSeconds(state: SessionStateModel): number | null {
    return state?.expiresInSeconds;
  }

  @Selector()
  static expiresAt(state: SessionStateModel): string | null {
    return state?.expiresAt;
  }

  @Action(SetSession)
  setSession(ctx: StateContext<SessionStateModel>, action: SetSession) {
    const expiresAt = new Date(
      Date.now() + action.expiresInSeconds * 1000
    ).toISOString();
    ctx.patchState({
      ssoToken: action.ssoToken,
      refreshToken: action.refreshToken,
      expiresInSeconds: action.expiresInSeconds,
      expiresAt,
    });
  }

  @Action(ClearSession)
  clearSession(ctx: StateContext<SessionStateModel>) {
    ctx.setState({
      ssoToken: null,
      refreshToken: null,
      expiresInSeconds: null,
      expiresAt: null,
    });
  }
}
